const eventName = 'nearpeer-profile-topics-changed';

exports.eventName = eventName;

exports.notify = () => {

    if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event(eventName));
    }
};
